<template>
  <div class="relative w-screen">
    <!-- Spacer with gradient transition -->
    <div class="h-24 w-full bg-gradient-to-b from-transparent to-inky-depths-950"></div>
    <!-- Site navigation links -->
    <div class="w-full flex flex-col gap-8 pb-16 bg-inky-depths-950">
      <div class="px-8 md:px-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-nowrap">
        <div v-for="(footerItem, index) in footerItems" :key="index">
          <p class="font-semibold">{{ footerItem.title }}</p>
          <div class="flex flex-col gap-2 mt-4 md:mt-8 underline font-light text-wave-crest-300">
            <NuxtLink
              v-for="(footerLink, footerLinkIndex) in footerItem.links"
              :key="footerLinkIndex"
              :to="{ name: footerLink.routeName }"
              class="transition-opacity cursor-pointer hover:opacity-70"
              >{{ footerLink.name }}</NuxtLink
            >
          </div>
        </div>
        <div class="flex flex-col justify-center">
          <div class="flex items-top gap-1">
            <div class="w-5 h-5 aspect-square]">
              <Icon name="map-pin" class="w-full h-full" />
            </div>
            <div class="text-sm font-light">
              <p>Hoults Yard</p>
              <p>Mailing Exchange</p>
              <p>Newcastle upon Tyne</p>
              <p>NE6 2HL</p>
              <p>United Kingdom</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Logo and socials -->
      <div class="flex justify-between items-top py-8 px-8 md:px-16 border-t border-b border-inky-depths-200">
        <img src="/assets/logos/ceto-logo-light.png" alt="Ceto logo" class="h-12 md:h-16" />
        <div class="flex items-center gap-2">
          <NuxtLink
            to="https://x.com/cetoai"
            class="flex items-center justify-center w-12 aspect-square bg-inky-depths-800 rounded transition-opacity hover:opacity-70">
            <Icon name="material-x-twitter" class="w-6 h-6 fill-wave-crest-50" />
          </NuxtLink>
          <NuxtLink
            to="https://www.linkedin.com/company/cetoai/posts/?feedView=all"
            class="flex items-center justify-center w-12 aspect-square bg-inky-depths-800 rounded transition-opacity hover:opacity-70">
            <Icon name="material-linkedin" class="w-6 h-6 fill-wave-crest-50" />
          </NuxtLink>
        </div>
      </div>
      <!-- Legal area -->
      <div>
        <div class="px-8 md:px-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div class="flex items-top text-left justify-start gap-4 text-nowrap font-light text-sm text-wave-crest-300 underline">
            <NuxtLink to="privacy">Privacy Policy</NuxtLink>
            <NuxtLink to="cookies">Cookies Policy</NuxtLink>
            <NuxtLink to="terms-and-conditions" class="text-wrap">Terms and Conditions</NuxtLink>
          </div>
          <div class="text-xs md:text-right font-light text-wave-crest-300">
            <p>CetoAI is a private limited company registered in England and Wales with company registration number 12472339.</p>
            <p>The registered office is at Hoults Yard, Mailing Exchange, Walker Road, Newcastle Upon Tyne, England, NE6 2HL.</p>
          </div>
        </div>
        <p class="mt-8 text-wave-crest-300 font-light text-sm text-center">© {{ currentYear }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear()

const footerItems = [
  {
    title: 'Products',
    links: [
      { name: 'CarbonID', routeName: 'carbonid' },
      { name: 'Watchkeeper', routeName: 'watchkeeper' },
      { name: 'Connected Insurance', routeName: 'insurance' }
    ]
  },
  {
    title: 'Resources',
    links: [
      // { name: 'FAQ', routeName: '' },
      { name: 'News', routeName: 'news' },
      { name: 'Media Kit', routeName: 'design' }
    ]
  },
  {
    title: 'Company',
    links: [
      { name: 'About', routeName: 'about' },
      { name: 'Contact', routeName: 'contact' },
      { name: 'Careers', routeName: 'careers' }
    ]
  }
]
</script>
